import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router,ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-component-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutComponent implements OnInit, AfterContentChecked {
    isMobile = window.innerWidth < 1000 ? true : false;

    constructor(
        private router: Router,
        private titleService: Title,
        private activeRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef) {
        this.titleService.setTitle("About");
    }

    ngOnInit() { }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }
}